import { render, staticRenderFns } from "./ActiveSubstanceDelete.vue?vue&type=template&id=779ffa52&scoped=true&"
import script from "./ActiveSubstanceDelete.vue?vue&type=script&lang=js&"
export * from "./ActiveSubstanceDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779ffa52",
  null
  
)

export default component.exports